//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  name: "AlbumSections",

  data() {
    return {
      maximizedToggle: true,
    };
  },

  computed: {
    paDialog: {
      get() {
        return this.$store.state.monuments.albumSectionsDialog;
      },
      set: function () {
        this.$store.dispatch("monuments/toggleAlbumSectionsDialog");
      }
    },

    photoAlbums() {
      return this.$store.getters["monuments/getSelectedItemPhotoAlbums"];
    },

    selectedDate() {
      // console.log('selectedDate()...');
      // return this.$store.getters["monuments/getSelectedPhotoDate"];
      return this.$store.state.monuments.selectedItem.albumDate;
    },

    currentDateAlbum() {
      const returnItem = this.$store.state.monuments.selectedItem && this.$store.state.monuments.selectedItem.images.length > 0 ?
          this.photoAlbums.filter(item => item.date === this.$store.state.monuments.selectedItem.albumDate)[0].sections : [];
      // console.log('@Carousel.vue :: @currentAlbumSection >> ', returnItem);
      return returnItem;
    },
  },

  methods: {

    openNext: function (selectedSection) {
      // console.log('@AlbumSections.vue :: @openNext >> selected section: ', selectedSection);
      // set new section
      this.$store.dispatch("monuments/setAlbumSelectedSection", selectedSection);
      // next step for selected date
      // console.log('@AlbumSections.vue :: @openAlbumPhotoGallery');
      this.$store.dispatch("monuments/toggleAlbumPhotoGalleryDialog");

    },
  },

  mounted() {
  },
}
